const DEBUG = process.env.NODE_ENV === "development";


export function log(...args) {
  if (DEBUG) console.log("[LOG]", ...args);
}

export function warn(...args) {
  if (DEBUG) console.warn("[WARN]", ...args);
}

export function error(...args) {
  console.error("[ERROR]", ...args);
}
export function info(...args) {
  if (DEBUG) console.info("[INFO]", ...args);
}